module.exports = __webpack_public_path__ + "static/media/remove-white.da5ea0a1.svg";